@if(isEditable){
<!-- Versión editable -->
<div id="financialServiceMobile">
  <h3>Servicio financiero</h3>
  <form [formGroup]="formFinancialService">
    <div class="wrapper">
      <div class="companiaYNumero">
        <div class="controlWrapper">
          <label for="">Compañia <span class="required">*</span></label>
          <div class="customSelect">
            <select
              type="text"
              formControlName="companyName"
              (blur)="onChangeCompany()"
            >
              <option [value]="'SOFOM'">SOFOM</option>
              <option [value]="'DTFS'">DTFS</option>
            </select>
          </div>
        </div>
        @if(idQuote){
        <div class="controlWrapper">
          <label for="">Número</label>
          <input
            type="number"
            [value]="idQuote"
            disabled
            (blur)="onInputFocus()"
          />
        </div>
        }
      </div>

      <div class="controlWrapper">
        <label for="">Distribuidor <span class="required">*</span></label>
        <div class="customSelect">
          <select
            type="text"
            formControlName="dealerId"
            (ngModelChange)="updateBranches()"
          >
            @for(dealer of dealers; track dealer.id){
            <option [ngValue]="dealer.id">
              {{ dealer.name }}
            </option>
            }
          </select>
        </div>
      </div>

      <!-- Mostrar solo si el usuario puede seleccionar Sucursal -->
      <div class="controlWrapper">
        <label for="">Sucursal <span class="required">*</span></label>
        <div class="customSelect">
          <select formControlName="dealerBranchId">
            @if(!hasBranches && dealerId !== null){
              <option [value]="null" hidden selected>
                {{ "No existen sucursales disponibles." }}
              </option>
            }@else {
            <option
              *ngFor="let dealerBranch of dealerBranches"
              [ngValue]="dealerBranch.id"
            >
              {{ dealerBranch.name }}
            </option>
            }
          </select>
        </div>
      </div>

      <div class="controlWrapper">
        <label for=""
          >Nombre de la cotización <span class="required">*</span></label
        >
        <input
          name=""
          type="text"
          id="price"
          formControlName="quoteName"
          (blur)="onInputFocus()"
        />
      </div>

      <div class="vigenciaYEstado">
        <div class="controlWrapper">
          <label for="">Vigencia <span class="required">*</span></label>
          <div class="customSelect">
            <select
              type="text"
              formControlName="daysOfValidity"
              (blur)="onInputFocus()"
            >
              <option [value]="15">15 días</option>
              <option [value]="30">30 días</option>
            </select>
          </div>
        </div>
        @if(idQuote){
        <div class="controlWrapper">
          <label for="">Estado</label>
          <div class="customSelect">
            <select type="text" formControlName="statusType">
              @for(status of financialCalculator.statusType; track
              status.value){
              <option [value]="status.value">
                {{ status.name }}
              </option>
              }
            </select>
          </div>
        </div>
        }
      </div>
    </div>
  </form>
</div>
} @if (!isEditable){
<!-- Versión sólo lectura -->
<div id="financialServiceMobile" class="readOnly">
  @if (!isModeEdition() && showReadonlyQuoteBelongsToOtherUser) {
    <div class="author">
      Esta cotización pertenece a {{ userName }} y no puede ser modificada.
    </div>
  }
  <h3>Servicio financiero</h3>
  <div>
    <div class="wrapper">
      <div class="companiaYNumero">
        <div>
          <label>Compañia</label>
          <span class="value">{{
            formFinancialService.controls["companyName"].value
          }}</span>
        </div>
        <div>
          <label>Número</label>
          <span class="value">{{ idQuote }}</span>
        </div>
      </div>

      <div>
        <label>Distribuidor</label>
        <span class="value">
          {{
            getNameById(
              formFinancialService.controls["dealerId"].value,
              "dealer"
            )
          }}
        </span>
      </div>

      <!-- Mostrar Sucursal solo si corresponde -->
      <div>
        <label>Sucursal</label>
        <span class="value">{{ getNameById(formFinancialService.controls["dealerBranchId"].value, 'branch') }}</span>
      </div>

      <div>
        <label>Nombre de la cotización</label>
        <span class="value">{{
          formFinancialService.controls["quoteName"].value
        }}</span>
      </div>

      <div class="vigenciaYEstado">
        <div>
          <label>Vigencia</label>
          <span class="value"
            >{{
              formFinancialService.controls["daysOfValidity"].value
            }}
            días</span
          >
        </div>
        <div>
          <label>Estado</label>
          @if (showStatusSelectInReadOnly) {
            <div class="customSelect" [formGroup]="formFinancialService">
              <select type="text" formControlName="statusType">
                @for (status of statusSelectOptions; track status.value) {
                  <option [value]="status.value">
                    {{ status.name }}
                  </option>
                }
              </select>
            </div>
          } @else {
            <div class="tag">
              {{ getStatus(formFinancialService.controls["statusType"].value) }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}
